<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="flex items-center justify-between">
                <div>
                    <span class="text-base font-extrabold text-slate-700 lg:text-xl">Preferred Group</span>
                    <div class="text-sm text-slate-500">Limit Contacts to Preferred Group</div>
                </div>
                <vx-toggle v-model="model" size="lg"></vx-toggle>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxToggle } from '@voxie/frontend-components';

const model = defineModel();
</script>
